import ApolloClientService from './apolloclient.service'
import SessionStorage from '../util/sessionstore'
import { constants } from '../constants'
import Axios from 'axios'
const session = new SessionStorage()
const service = new ApolloClientService()

export default class Actioncase {
  fetchCases = (params) => {
    return new Promise((resolve, reject) => {
      service
        .fetchCases(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getPatientMessages= (params) => {
    return new Promise((resolve, reject) => {
      service
        .getPatientMessages(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data.data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }
  isNewActionCase = (customerid, surgeonId, companyId) => {
    return new Promise((resolve, reject) => {
      service
        .isNewActionCase(customerid, surgeonId, companyId)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  deleteActionCase = (params) => {
    return new Promise((resolve, reject) => {
      service
        .deleteActionCase(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }
  getHealthCoachList = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getHealthCoachNameList(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  createNewCase = (params) => {
    return new Promise((resolve, reject) => {
      service
        .createNewCase(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            console.log('UDP', data)
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getActionCase = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getActionCase(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }
  assignedToMoveAi = (caseId) => {
    return new Promise((resolve, reject) => {
      service
        .assignedToMoveAi(caseId)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }
  getMessageCase = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getMessageCase(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getImageUrl = (params) => {
    let profile = session.getProfile()
    const token = profile?.token

    return new Promise((resolve, reject) => {
      Axios.post(
        constants.API_URL + '/images/messages',
        { fileName: params.fileName },       
        {
          responseType: 'blob',
          headers: {
            'x-authorization': 'Bearer ' + token 
          }
        }
      )
        .then((data) => {
          if (data?.data) {
            const url = URL.createObjectURL(new Blob([data.data]));
            resolve({imageUrl:url})
          } else {
            data.error = true
            reject(data)
          }
        })
      .catch(async (err) => {
              console.log(err, "Error in getImageUrl");

              if (err.response && err.response.data instanceof Blob) {
                try {
                  const text = await err.response.data.text();
                  const json = JSON.parse(text);
                  return reject(json); 
                } catch (e) {
                  return reject({ error: true, message: 'Image not found' });
                }
              }
              reject({ error: true, message: err.message || 'Image not found' });
            });
          })
  }
 
  getPatientsFourdigits = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getPatientsFourdigits(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  bulkUpdateActionCases = (params) => {
    return new Promise((resolve, reject) => {
      service
        .bulkUpdateActionCases(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  updateActionCase = (params) => {
    return new Promise((resolve, reject) => {
      service
        .updateActionCase(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  deleteWorkLog = (params) => {
    return new Promise((resolve, reject) => {
      service
        .deleteWorkLog(params)
        .then((data) => {
          console.log('deleteWorkLog==', data)
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  deleteComment = (params) => {
    return new Promise((resolve, reject) => {
      service
        .deleteComment(params)
        .then((data) => {
          console.log('deleteComment==', data)
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  editWorkLog = (params) => {
    return new Promise((resolve, reject) => {
      service
        .editWorkLog(params)
        .then((data) => {
          console.log('editWorkLog==', data)
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  updateLastViewed = (caseid) => {
    return new Promise((resolve, reject) => {
      service
        .updateLastViewed(caseid)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  editComment = (params) => {
    return new Promise((resolve, reject) => {
      service
        .editComment(params)
        .then((data) => {
          console.log('editComment==', data)
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  addComment = (input) => {
    return new Promise((resolve, reject) => {
      service
        .addComment(input)
        .then((data) => {
          if (data.status == true) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getActionCaseStats = (customerid) => {
    return new Promise((resolve, reject) => {
      let profile = session.getProfile()
      let id = ''
      if (profile.customer?._id) id = profile.customer?._id
      else id = customerid
      service
        .getActionCaseStats({ customerid: id })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = 'Service Error'
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
}
